module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=WS - Samoa.69c040d2.svg";